import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ScreenShareicon from '@mui/icons-material/ScreenShare';
import DoneIcon from '@mui/icons-material/Done';

import Loading from 'components/UI/Loading/Loading';
import StepThree from './StepThree/StepThree';
import StepTwo from './StepTwo/StepTwo';
import StepOne from './StepOne/StepOne';

import {
  getCredentialsUploadEvaluationS3,
  uploadHomework
} from 'store/lesson-actions';
import classes from './ActivityUpload.module.css';

const ActivityUpload = props => {
  const { t } = useTranslation(['lesson']);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadActivityStatus, setUploadActivityStatus] =
    useState(false);
  const [uploadBtn, setUploadButton] = useState(true);
  const [activityTitle, setActivityTitle] = useState('');
  const [idLesson] = useState(props.idLesson);
  const [archive, setArchive] = useState(false);

  useEffect(() => {
    if (activityTitle.length > 0 && archive) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  }, [archive, activityTitle]);

  const uploadButtonEnabledHandler = status => {
    setUploadButton(status);
  };

  const uploadHandler = async data => {
    setIsLoading(true);
    console.log(data);

    const credentialsUploadEvaluation =
      await getCredentialsUploadEvaluationS3(
        idLesson,
        activityTitle
      );
    if (credentialsUploadEvaluation) {
      const uploadEvaluation = await uploadHomework(
        credentialsUploadEvaluation.credentials,
        archive
      );
      if (uploadEvaluation) {
        setUploadActivityStatus(true);
        setIsLoading(false);
      }
    }
  };

  const activityTitleHandler = title => {
    setActivityTitle(title);
  };

  const archiveHandler = file => {
    setArchive(file);
  };

  return (
    <>
      <div className={classes.activityContainer}>
        {!uploadActivityStatus ? (
          <div className={classes.contentActivities}>
            <StepOne
              uploadButtonEnabled={uploadButtonEnabledHandler}
              archiveHandler={archiveHandler}
            />
            <StepTwo activityTitleHandler={activityTitleHandler} />
            <StepThree />
          </div>
        ) : (
          <div className={classes.uploadActivityDoneContainer}>
            <DoneIcon className={classes.doneIcon} />
            <p>{t('uploaded_file_successfully')}</p>
            <Button
              className={classes.nextBtn}
              onClick={props.returnVideo}
            >
              {t('continue')}
            </Button>
          </div>
        )}
      </div>
      <aside className={classes.btnsContainer}>
        {!isLoading ? (
          !uploadActivityStatus && (
            <>
              <Button
                onClick={props.changeView}
                className={classes.nextBtn}
              >
                {t('instructions')} <AssignmentIcon />
              </Button>
              <Button
                disabled={uploadBtn}
                onClick={uploadHandler}
                className={classes.nextBtn}
              >
                {t('save_and_send')} <ScreenShareicon />
              </Button>
            </>
          )
        ) : (
          <Loading />
        )}
      </aside>
    </>
  );
};

ActivityUpload.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  returnVideo: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeHomeworkStatus: PropTypes.func
};

export default ActivityUpload;
